var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenPopupIconBlueWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.2 17.2",
    style: {
      enableBackground: "new 0 0 17.2 17.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-external-link",
    transform: "translate(-4 -4.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    className: "st0",
    d: "M18.7,13.9v5.7c0,1-0.8,1.9-1.9,1.9H6.4c-1,0-1.9-0.8-1.9-1.9V9.2c0-1,0.8-1.9,1.9-1.9h5.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    className: "st0",
    d: "M14.8,5.5h5.7v5.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    className: "st0",
    d: "M10.1,15.9L20.5,5.5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenPopupIconBlueWhite);
export default __webpack_public_path__ + "static/media/OpenPopupIconBlueWhite.995eb33791f67252de4ec8b4ca9dad50.svg";
export { ForwardRef as ReactComponent };